import Constant from 'BASE/common/lotteryConstant';
import { urlCombine } from 'BASE/common/util/util.apiProxy';
import { browser } from '#BASE/common/util/util.browser';
import { storage } from 'BASE/common/util/util.storage';

const GAME_WINDOW_NAME = 'gameWindow';

export class DefaultExternalGameConfig {
    constructor(gameType, width, height, transferThroughGame, windowOpenOption, supportIOSIFrame) {
        this.gameType = gameType;
        this.width = width || 0;
        this.height = height || 0;
        // 是否可以在遊戲進行中轉帳
        this.transferThroughGame = transferThroughGame !== undefined ? transferThroughGame : true ;
        this.windowOpenOption = windowOpenOption;
        this.supportIOSIFrame = supportIOSIFrame !== undefined ? supportIOSIFrame : true;
    }

    loginGameAction(result) {
        if(ENVIRONMENT.CORDOVA){
            window.PresentAlertConfirm(result.LoginUrl);
        }else{
            let option = this.windowOpenOption || GAME_WINDOW_NAME;
            window.open(result.LoginUrl, option);
        }
    }
}

export default {
    name: 'GoExternalGameBase',
    data: function () {
        return {
            LOTTO_CATEGORY_CONSTANT: Constant.LottoCategory,
            GAME_TYPE_CONSTANT: Constant.GameType,
            ExternalGameClassification: Constant.ExternalGameClassification,
            //外接遊戲設定參數
            config: {
                gameTypeConfig: {} // 在created初始化
            },
            //餘額
            balance: '读取中',
            gameBalanceList: {

            },
            // 遊戲清單參數
            gameItemPara: {
                gameType: '',
                classification: '',
                gameItems: []
            },
            IsPlatformMaintaining: false,
            MaintenanceTime: '',
            // 自動將金額全部轉至外接
            autoTransAmount: false,

            // 裝置、瀏覽器判別用
            ua: navigator.userAgent,
        };
    },
    watch: {
        'gameItemPara.gameType': function (val, oldVal) {
            if (val !== '') {
                this.getGameItems();
            }
        },
    },
    computed: {
        currentUrl() { // 當前網址，遊戲返回使用
            return window.location.href;
        },
        isMobileBrowser() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(this.ua);
        },
        isAppUse() { //判斷是否是app用
            return this.ua.indexOf("UseApp") > -1;
        },
        isIOSBrowser() {
            return /iPad|iPhone|iPod/.test(this.ua) && !window.MSStream;
        },
        isQQBrowser() { //ua中包含MQQBrowser(QQ内置浏览器及QQ浏览器都有)
            return /mqqbrowser/i.test(this.ua.toLowerCase());
        },
        isCordova() {
            return ENVIRONMENT.CORDOVA;
        },
        isPWA() {
            return storage.local.get(storage.keys.ISPWA) ? true : false;
        },
        isWebview: {
            get() {
                let isWebview = (/micromessenger/i.test(this.ua.toLowerCase())) || (/line/i.test(this.ua.toLowerCase())) || this.isQQBrowser;
                if (!this.isIOSBrowser) { //如果不是ios，要區分是QQ内置浏览器或是QQ浏览器
                    isWebview = isWebview && /qq/i.test(this.ua.toLowerCase().split('mqqbrowser')); // 用RegExp判断ua中包含MQQBrowser并且之后包含QQ，则是QQ内置浏览器，ua中包含MQQBrowser但是不包含QQ则是QQ浏览器        
                    //内置浏览器  Mozilla/5.0 (Linux; U; Android 5.0.2; zh-cn; X900 Build/CBXCNOP5500912251S) AppleWebKit/533.1 (KHTML, like Gecko)Version/4.0 MQQBrowser/5.4 TBS/025489 Mobile Safari/533.1 V1_AND_SQ_6.0.0_300_YYB_D QQ/6.0.0.2605 NetType/WIFI WebP/0.3.0 Pixel/1440
                    //    浏览器  Mozilla/5.0 (Linux; U; Android 5.0.2; zh-cn; X900 Build/CBXCNOP5500912251S) AppleWebKit/533.１ (KHTML, like Gecko) Version/4.0 Chrome/57.0.2987.132 MQQBrowser/8.8 Mobile Safari/533.1
                }
                return isWebview;
            }
        },
        codeNameAry() {
            let revertObje = {};

            //後續若有要rename, 從這邊加入可overWrite物件
            Object.keys(Constant.GameType).forEach((key)=>{
                revertObje[Constant.GameType[key]] = key;
            });
            
            return revertObje;
        },
        walletAmount() {
            return this.$store.state.userinfo.walletAmount;
        },
    },
    methods: {
        async getVRLottery() { // 取得VR彩票
            let _this = this;
            try {
                let res = await $.getJSON(`/api/ExternalGame/GameItems/${Constant.GameType.VRGame}${'/' + Constant.ExternalGameClassification.LOTTERY}`);
                for (let item of res) {
                    item.IconFilePath = urlCombine(item.IconFilePath);
                }
                return res;
            }
            catch (e) {
                _this.$dialog.warning("发生错误", {}, e.status);
            }
        },
        async getGameItems() { // 取得外接遊戲清單
            let _this = this;
            try {
                let res = await $.getJSON(`/api/ExternalGame/GameItems/${this.gameItemPara.gameType}${this.gameItemPara.classification !== '' ? ('/' + this.gameItemPara.classification) : ''}`);
                for (let item of res) {
                    item.IconFilePath = urlCombine(item.IconFilePath);
                }
                this.gameItemPara.gameItems = res;
            }
            catch (e) {
                _this.$dialog.warning("发生错误", {}, e.status);
            }
        },
        async getGameItemsReturn(gameType, classification){
            try {
                let res = await $.getJSON(`/api/ExternalGame/GameItems/${gameType}${classification !== undefined && classification !== '' ? ('/' + classification) : ''}`);
                for (let item of res) {
                    item.IconFilePath = urlCombine(item.IconFilePath);
                }
                return res;
            }
            catch (e) {
                return [];
            }
        },
        async getGameNames() { // 取得外接遊戲名稱
            let _this = this;
            let data = storage.local.get(storage.keys.EXTERNAL_GAME_NAMES);
            if (data) {
                return data;
            }

            try {
                data = await $.getJSON('/api/ExternalGame/GetExternalGameNames');
                storage.local.set(storage.keys.EXTERNAL_GAME_NAMES, data);
                return data;
            } catch (e) {
                _this.$dialog.warning("发生错误", {}, e.status);
            }
        },
        getExternalGameBalance(externalGameType) {
            let _this = this;
            return $.ajax({
                url: '/api/ExternalGameTrans/GetExternalGameBalance/' + externalGameType,
                type: 'POST',
                data: {
                    gameType: externalGameType
                },
                success: function (data) {
                    _this.gameBalanceList[externalGameType]=data;
                    _this.balance = data;
                },
                error: function () {
                    _this.balance = 0;
                }
            });
        },
        getMatainStatus(externalGameType) {
            let _this = this;
            $.ajax({
                url: '/api/ExternalGame/IsPlatformMaintaining/' + externalGameType,
                async: false,
                type: 'GET',
                success: function (data) {
                    _this.IsPlatformMaintaining = data.IsMaintain;
                    _this.MaintenanceTime = data.MaintenanceTime;
                },
                error: function () {
                }
            });
        },
        updateBalance(gameType,balance) {
            this.gameBalanceList[gameType] = balance;
        },
        async getGameItemsByGameTypes(gameTypes) { // 取得外接遊戲清單
            if (Array.isArray(gameTypes)) {
                let _this = this;
                try {
                    let str = "";
                    for (let gameType of gameTypes) {
                        str += "gameTypes=" + gameType + "&";
                    }
                    let res = await $.getJSON('/api/ExternalGame/GetGameItemsByGameTypes?' + str.slice(0,-1));
                    let obj = {};
                    for (let key in res) {
                        for (let item of res[key]) {
                            item.IconFilePath = urlCombine(item.IconFilePath);
                        }
                        obj[Constant.GameType[key]] = res[key];
                    }
                    return obj;
                } catch (e) {
                    _this.$dialog.warning("发生错误");
                }
            }
        },
        isSWGame(gameType) {
            return Constant.ExternalGameSWTypes.some(s => s == gameType);
        },
        async showTransOrEnterGame(gameType, postData) {
            if (this.isSWGame(gameType)) {
                await this.enterExternalGame(gameType, postData);
            } else {
                this.showExternalGameTrans(gameType, postData);
            }
        },
        showExternalGameTrans(gameType, postData) { // 顯示外接轉點視窗
            this.$refs.externalGameTransComponent.init(gameType, postData);
        },
        async enterExternalGame(gameType, postData) { // 直接進入外接遊戲
            let _this = this;
            let gameTypeConfig = _this.config.gameTypeConfig[gameType];
            // 找不到外接設定
            if (gameTypeConfig === undefined) {
                _this.$dialog.warning("发生错误");
                return;
            }
            
            try {
                if (typeof postData === 'undefined') postData = {};
                // 取得開啟遊戲方式, 啟用Iframe直接跳轉
                let gameStartOption = await $.postJSON('/api/ExternalGame/GetGameConfig/' + gameTypeConfig.gameType);
                if(gameStartOption.IsMaintain)
                {
                    let msg = '维护中';
                    if (gameStartOption.MaintenanceTime) {
                        msg = '维护中，结束维护时间 ' + gameStartOption.MaintenanceTime;
                    }
                    _this.$dialog.warning(msg);
                    return;
                }
                
                if(gameStartOption.IFrame && (!this.isIOSBrowser || gameTypeConfig.supportIOSIFrame)){
                    _this.closeGameWindow();
                    this.$router.push({ name: 'IFrame', query: { Id: gameTypeConfig.gameType, params: encodeURIComponent(JSON.stringify(postData)) } });
                    return;
                }

                postData['gameType'] = gameTypeConfig.gameType;
                //isCordova 直接使用 window.open("http://xxx") 直接開啟外部瀏覽器
                if (!gameTypeConfig.windowOpenOption && !this.isCordova) {
                    window.name = "";

                    _this.closeGameWindow();

                    if (!this.isAppUse && !this.isWebview && !this.isPWA)
                        window.ExternalGameWindow = window.open("about:blank", GAME_WINDOW_NAME, "height=" + gameTypeConfig.height + ",width=" + gameTypeConfig.width + ",resizable");
                    else
                        window.name = GAME_WINDOW_NAME;
                }
                let res = await $.postJSON('/api/ExternalGame/CreateOrLogin', postData);
                if (res.Success) {

                    // 進入前轉入所有金額，如果開啟遊戲時不允許轉帳則先等轉帳完畢後再開啟遊戲
                    if (_this.autoTransAmount) {
                        if(gameTypeConfig.transferThroughGame){
                            $.postJSON('/api/ExternalGameTrans/RecyleAndTransAll', { GameType: gameType, SystemTrans: true });
                        }else{
                            await $.postJSON('/api/ExternalGameTrans/RecyleAndTransAll', { GameType: gameType, SystemTrans: true });
                        }
                    }

                    // 進入遊戲
                    if(gameStartOption.IFrame && this.isCordova)
                        window.OpenInAppBrowser(res.LoginUrl);
                    else
                        gameTypeConfig.loginGameAction(res);
                        
                } else {
                    _this.$dialog.warning(res.ErrMsg || "发生错误");
                    _this.closeGameWindow();
                }
            }
            catch (e) {
                _this.$dialog.warning("发生错误", {}, e.status);
                _this.closeGameWindow();
            }
        },
        closeGameWindow() {
            if (window.ExternalGameWindow && !window.ExternalGameWindow.closed) {
                window.ExternalGameWindow.close();
                window.ExternalGameWindow = undefined;
            }
        },
        showTransModal(transModalName) {
            this.$dialog.get(transModalName).show();
        },
        closeTransModal(transModalName) {
            this.$dialog.get(transModalName).hide();
        },
        async directToDifferentEntrance(game) { // 根據Mode選擇開啟方式
            
            var extParam = this.getExtParam(game.Id, game.GameType);
            if(game.Mode == 3) {  // 跳轉
                this.ToLobbyPage(game);
            }
            else if(game.Mode == 2 && this.$refs.externalGameTransComponent) {  // 開啟資金轉換頁
                this.showExternalGameTrans(game.GameType, extParam);
            }
            else {  // 直接進入遊戲
                await this.enterExternalGame(game.GameType, extParam);
            }
        },
        getExtParam(Id, gameType) {
            var extParam = {};
            if (gameType == this.GAME_TYPE_CONSTANT.AG) {
                if (Id == 1)
                    extParam.gameCode = 0;
                if (Id == 2)
                    extParam.gameCode = 6;
                if(Id == 3)
                    extParam.gameCode = 8;
                return extParam;
            }
            if (gameType == this.GAME_TYPE_CONSTANT.TGP) {
                if (Id == 1) {
                    extParam.gameCode = "EA_Lobby";
                    extParam.extraParameter = JSON.stringify({ GameProviders: 'EA', platform: 0 });
                }
                if (Id == 2) {
                    extParam.gameCode = "Gold_Deluxe_Lobby";
                    extParam.extraParameter = JSON.stringify({ GameProviders: 'GD', platform: 0 });
                }
                if(Id == 3) {
                    extParam.gameCode = "ESB";
                    extParam.extraParameter = JSON.stringify({ GameProviders: 'ESB', platform: 0 });
                }
                return extParam;
            }
            if (gameType == this.GAME_TYPE_CONSTANT.JDB) {
                extParam.gameCode = 0;
                extParam.extraParameter = "1";

                return extParam;
            }
            if (gameType == this.GAME_TYPE_CONSTANT.VRGame) {
                extParam.gameCode = 10000;

                return extParam;
            }
            if (gameType == this.GAME_TYPE_CONSTANT.BBin || gameType == this.GAME_TYPE_CONSTANT.BBin2) {
                if (Id == 1)
                    extParam.extraParameter = "live";
                if (Id == 2)
                    extParam.extraParameter = "game";

                return extParam;
            }
            if (gameType == this.GAME_TYPE_CONSTANT.EGP_BBIN) {
                if (Id == 1)
                    extParam.extraParameter = "60";
                if (Id == 2)
                    extParam.extraParameter = "61";
                if (Id == 3)
                    extParam.extraParameter = "62";
                if (Id == 4)
                    extParam.extraParameter = "64";
                    
                return extParam;
            }
            if (gameType == this.GAME_TYPE_CONSTANT.EGP_AWC) {
                if (Id == 1)
                    extParam.extraParameter = JSON.stringify({ platform: 'SEXYBCRT', gameType: 'LIVE' });
                   
                return extParam;
            }
            return extParam;
        },
        ToLobbyPage(game) {
            if (game.GameType < 1000 ) {
                this.$router.push({ path: '/ExternalGameSubItem/' + game.GameType });
            }
            else {
                if (game.GameType == Constant.GameType.CARD) {
                    this.$router.push({ path: '/ExternalGame/Card' });
                }
                if (game.GameType == Constant.GameType.VIDEO_SLOT) {
                    if (game.Id == 1)
                        this.$router.push({ path: '/ExternalGame/VideoSlot' });
                    else
                        this.$router.push({ path: '/ExternalGame/VideoGame' });
                }
                if (game.GameType == Constant.GameType.SPORT) {
                    this.$router.push({ path: '/ExternalGame/Sport' });
                }
                if (game.GameType == Constant.GameType.YBGAME) {  // 雲豹大廳
                    this.$router.push({ path: '/ExternalGame/YB' });
                }
            }
        },
    },
    created() {
        this.config.gameTypeConfig[Constant.GameType.AS] = new DefaultExternalGameConfig(Constant.GameType.AS, 1200, 900);
        this.config.gameTypeConfig[Constant.GameType.YC] = new DefaultExternalGameConfig(Constant.GameType.YC, 1280, 720);
        this.config.gameTypeConfig[Constant.GameType.KY] = new DefaultExternalGameConfig(Constant.GameType.KY, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.AG] = new DefaultExternalGameConfig(Constant.GameType.AG, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.BBin] = new DefaultExternalGameConfig(Constant.GameType.BBin, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.CQ9] = new DefaultExternalGameConfig(Constant.GameType.CQ9, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.GAMMA] = new DefaultExternalGameConfig(Constant.GameType.GAMMA, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.UG] = new DefaultExternalGameConfig(Constant.GameType.UG, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.VRGame] = new DefaultExternalGameConfig(Constant.GameType.VRGame, 1280, 720, undefined, undefined, false);
        this.config.gameTypeConfig[Constant.GameType.FC] = new DefaultExternalGameConfig(Constant.GameType.FC, 1200, 800);             
        this.config.gameTypeConfig[Constant.GameType.IM] = new DefaultExternalGameConfig(Constant.GameType.IM, 1200, 800);            
        this.config.gameTypeConfig[Constant.GameType.DONGSEN] = new DefaultExternalGameConfig(Constant.GameType.DONGSEN, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.TGP] = new DefaultExternalGameConfig(Constant.GameType.TGP, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.JDB] = new DefaultExternalGameConfig(Constant.GameType.JDB, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.LEG] = new DefaultExternalGameConfig(Constant.GameType.LEG, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.TM] = new DefaultExternalGameConfig(Constant.GameType.TM, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.YB] = new DefaultExternalGameConfig(Constant.GameType.YB, 1200, 800, false); 
        this.config.gameTypeConfig[Constant.GameType.BBin2] = new DefaultExternalGameConfig(Constant.GameType.BBin2, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.SB] = new DefaultExternalGameConfig(Constant.GameType.SB, 1400, 900);
        this.config.gameTypeConfig[Constant.GameType.EBET] = new DefaultExternalGameConfig(Constant.GameType.EBET, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.IBO] = new DefaultExternalGameConfig(Constant.GameType.IBO, 1200, 800, undefined, undefined, false);
        this.config.gameTypeConfig[Constant.GameType.DREAMWORK] = new DefaultExternalGameConfig(Constant.GameType.DREAMWORK, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.CR] = new DefaultExternalGameConfig(Constant.GameType.CR, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.CMD] = new DefaultExternalGameConfig(Constant.GameType.CMD, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.XBB] = new DefaultExternalGameConfig(Constant.GameType.XBB, 1400, 800);
        this.config.gameTypeConfig[Constant.GameType.EGP_AG] = new DefaultExternalGameConfig(Constant.GameType.EGP_AG, 1200, 800, undefined, undefined, false);
        this.config.gameTypeConfig[Constant.GameType.EGP_KY] = new DefaultExternalGameConfig(Constant.GameType.EGP_KY, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.EGP_BBIN] = new DefaultExternalGameConfig(Constant.GameType.EGP_BBIN, 1200, 800, undefined, undefined, false);
        this.config.gameTypeConfig[Constant.GameType.EGP_CR] = new DefaultExternalGameConfig(Constant.GameType.EGP_CR, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.EGP_AWC] = new DefaultExternalGameConfig(Constant.GameType.EGP_AWC, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.EGP_JDB] = new DefaultExternalGameConfig(Constant.GameType.EGP_JDB, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.EGP_CQ9] = new DefaultExternalGameConfig(Constant.GameType.EGP_CQ9, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.GDQ] = new DefaultExternalGameConfig(Constant.GameType.GDQ, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.EGP_SB] = new DefaultExternalGameConfig(Constant.GameType.EGP_SB, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.ICG] = new DefaultExternalGameConfig(Constant.GameType.ICG, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.EGP_FC] = new DefaultExternalGameConfig(Constant.GameType.EGP_FC, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.WALI] = new DefaultExternalGameConfig(Constant.GameType.WALI, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.CT] = new DefaultExternalGameConfig(Constant.GameType.CT, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.GR] = new DefaultExternalGameConfig(Constant.GameType.GR, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.ALLBET] = new DefaultExternalGameConfig(Constant.GameType.ALLBET, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.AVIA] = new DefaultExternalGameConfig(Constant.GameType.AVIA, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.PP] = new DefaultExternalGameConfig(Constant.GameType.PP, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.BTI_SW] = new DefaultExternalGameConfig(Constant.GameType.BTI_SW, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.MG] = new DefaultExternalGameConfig(Constant.GameType.MG, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.WM] = new DefaultExternalGameConfig(Constant.GameType.WM, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.IM_SW] = new DefaultExternalGameConfig(Constant.GameType.IM_SW, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.CR_SW] = new DefaultExternalGameConfig(Constant.GameType.CR_SW, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.OBSPORT_SW] = new DefaultExternalGameConfig(Constant.GameType.OBSPORT_SW, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.BAISON] = new DefaultExternalGameConfig(Constant.GameType.BAISON, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.CG_SW] = new DefaultExternalGameConfig(Constant.GameType.CG_SW, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.PMLIVE_SW] = new DefaultExternalGameConfig(Constant.GameType.PMLIVE_SW, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.HRG_SW] = new DefaultExternalGameConfig(Constant.GameType.HRG_SW, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.GC_SW] = new DefaultExternalGameConfig(Constant.GameType.GC_SW, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.BG] = new DefaultExternalGameConfig(Constant.GameType.BG, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.WE] = new DefaultExternalGameConfig(Constant.GameType.WE, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.HRG] = new DefaultExternalGameConfig(Constant.GameType.HRG, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.PG] = new DefaultExternalGameConfig(Constant.GameType.PG, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.ZZSIX] = new DefaultExternalGameConfig(Constant.GameType.ZZSIX, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.EGP_LEG] = new DefaultExternalGameConfig(Constant.GameType.EGP_LEG, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.SING3] = new DefaultExternalGameConfig(Constant.GameType.SING3, 1500, 800);
        this.config.gameTypeConfig[Constant.GameType.TIKI] = new DefaultExternalGameConfig(Constant.GameType.TIKI, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.BTI2] = new DefaultExternalGameConfig(Constant.GameType.BTI2, 1300, 800);
        this.config.gameTypeConfig[Constant.GameType.DBGAME_SW] = new DefaultExternalGameConfig(Constant.GameType.DBGAME_SW, 600, 1200);
        this.config.gameTypeConfig[Constant.GameType.GC_JDB_SW] = new DefaultExternalGameConfig(Constant.GameType.GC_JDB_SW, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.GC_FC_SW] = new DefaultExternalGameConfig(Constant.GameType.GC_FC_SW, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.GC_PG_SW] = new DefaultExternalGameConfig(Constant.GameType.GC_PG_SW, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.GC_HRG_SW] = new DefaultExternalGameConfig(Constant.GameType.GC_HRG_SW, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.GC_CHOICE_SW] = new DefaultExternalGameConfig(Constant.GameType.GC_CHOICE_SW, 1200, 800, undefined, undefined, false);
        this.config.gameTypeConfig[Constant.GameType.GC_CR_SW] = new DefaultExternalGameConfig(Constant.GameType.GC_CR_SW, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.GC_CQ9_SW] = new DefaultExternalGameConfig(Constant.GameType.GC_CQ9_SW, 1200, 800);
        this.config.gameTypeConfig[Constant.GameType.GC_COMBO_SW] = new DefaultExternalGameConfig(Constant.GameType.GC_COMBO_SW, 1200, 800);
        // // 部分手機瀏覽器不能使用"_blank", 例如:IOS
        // if (browser.isMobile) {
        //     this.config.gameTypeConfig[Constant.GameType.VRGame] = new DefaultExternalGameConfig(Constant.GameType.VRGame, 1280, 720);
        // } else {
        //     this.config.gameTypeConfig[Constant.GameType.VRGame] = new DefaultExternalGameConfig(Constant.GameType.VRGame, 0, 0, "_blank");
        // }
    }
}